/**
 * @flow
 * @relayHash bad0e2868ad274a6b202999ad77fc7da
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type PdpSharedFollowDealerMutationVariables = {|
  input: {
    sellerPk: string;
    userId: string;
    favoriteId?: ?string;
    clientMutationId?: ?string;
  };
  userId: string;
|};
export type PdpSharedFollowDealerMutationResponse = {|
  +favoriteSeller: ?{|
    +seller: ?{|
      +id: string;
      +favoritesByUser: ?$ReadOnlyArray<?{|
        +serviceId: ?string;
      |}>;
    |};
  |};
|};
*/


const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FavoriteSellerInput!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedFollowDealerMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FavoriteSellerInput!"
          }
        ],
        "concreteType": "FavoriteSellerPayload",
        "name": "favoriteSeller",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Seller",
            "name": "seller",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "Favorite",
                "name": "favoritesByUser",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": "app-buyer-mobile/173.0.0-2018-06-22T14:05:01.024Z/PdpSharedFollowDealerMutation",
  "kind": "Batch",
  "metadata": {},
  "name": "PdpSharedFollowDealerMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FavoriteSellerInput!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "PdpSharedFollowDealerMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FavoriteSellerInput!"
          }
        ],
        "concreteType": "FavoriteSellerPayload",
        "name": "favoriteSeller",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Seller",
            "name": "seller",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "Favorite",
                "name": "favoritesByUser",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": null
};

module.exports = batch;
